import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import ScheduleIcon from "@mui/icons-material/Schedule";
import VideocamIcon from "@mui/icons-material/Videocam";
import MicIcon from "@mui/icons-material/Mic";
import DescriptionIcon from "@mui/icons-material/Description";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";

export const APP_TITLE = "IGNA Scout";

export const DASHBOARD_STATS_DATA = [
  {
    id: "interview-conducted",
    title: "Interviews Scheduled",
    value: 24,
    icon: <CheckCircleIcon color="info" sx={{ fontSize: 20 }}/>,
    iconBg: "#e0eaf8",
  },
  {
    id: "pending-interview",
    title: "Interviews In Progress",
    value: 8,
    icon: <AccessTimeIcon color="warning" sx={{ fontSize: 20 }}/>,
    iconBg: "#f7e9d9",
  },
  
  // {
  //   id: "interview-failed",
  //   title: "Interview Failed",
  //   value: 3,
  //   icon: <CancelIcon sx={{ color: "#DC2626", fontSize: 20 }} />,
  //   iconBg: "#FEF2F2",
  // },
  {
    id: "interview-completed",
    title: "Interviews Completed",
    value: 3,
    icon: <CloudDoneIcon color="success" sx={{ fontSize: 20 }} />,
     iconBg: "#d5f8df",
  },
  {
    id: "reported-zoho",
    title: "Reported to Zoho",
    value: 21,
    icon: <IntegrationInstructionsIcon color="secondary" sx={{  fontSize: 20 }} />,
    iconBg: "#f7d7e2",
  },
];

export const STATUS_CONFIG = {
  Scheduled: {
    label: "Scheduled",
    bg: "#E3F2FD",
    color: "#2563EB",
  },
  ReScheduled: {
    label: "Rescheduled",
    bg: "#dab4da78",
    color: "#ba1295",
  },
  Completed: {
    label: "Completed",
    bg: "#d9f1ccd9",
    color: "#05af42",
  },
  InProgress: {
    label: "InProgress",
    bg: "#FFF4E5",
    color: "#ED6C02",
  },
  LinkExpired: {
    label: "Link Expired",
    bg: "#fedada",
    color: "#f41b1b",
  },
  Failed: {
    label: "Failed",
    bg: "#FFEBEE",
    color: "#D32F2F",
  },
  Video: {
    label: "Video",
    bg: "#f3e8ff",
    color: "#7c3aed",
    icon: VideocamIcon,
  },
  Audio: {
    label: "Audio",
    bg: "#dbeafe",
    color: "#2563eb",
    icon: MicIcon,
  },
  Text: {
    label: "Text",
    bg: "#f3f4f6",
    color: "#4b5563",
    icon: DescriptionIcon,
  },
};

export const ZOHO_SYNC_CONFIG = {
  Success: {
    label: "Success",
    icon: CheckCircleIcon,
    color: "#10b981",
    textColor: "#065f46",
    background: "#d1fae5",
  },
  Pending: {
    label: "Pending",
    icon: ScheduleIcon,
    color: "#f59e0b",
    textColor: "#92400e",
    background: "#fef3c7",
  },
  Failed: {
    label: "Failed",
    icon: CancelIcon,
    // color: "#6b7280",
    // textColor: "#374151",
    // background: "#f3f4f6",
    color: "#ef4444",
    textColor: "#7f1d1d",
    background: "#fee2e2",
  },
};
